import React from 'react';
import { Star } from 'lucide-react';
import { testimonials, restaurantInfo } from '../mock';

const Testimonials = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1552566626-52f8b828add9?w=1600')" }}>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Loved by Families Across Jabalpur
          </h1>
          <div className="flex items-center justify-center space-x-3 text-2xl">
            <Star className="w-8 h-8 text-[#F39C12] fill-current" />
            <span className="font-bold">{restaurantInfo.rating}</span>
            <span className="text-gray-200">({restaurantInfo.reviewCount}+ Reviews)</span>
          </div>
        </div>
      </section>

      {/* Rating Summary */}
      <section className="section-padding bg-[#FFF8F0]">
        <div className="container">
          <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-lg text-center">
            <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#2C3E50' }}>
              What Our Customers Say
            </h2>
            <div className="flex items-center justify-center space-x-2 text-[#F39C12] text-4xl mb-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className={`w-10 h-10 ${i < 4 ? 'fill-current' : ''}`} />
              ))}
            </div>
            <p className="text-5xl font-bold text-[#E84118] mb-2">{restaurantInfo.rating}/5.0</p>
            <p className="text-xl text-gray-700">
              Based on {restaurantInfo.reviewCount}+ verified Google reviews
            </p>
            <a
              href="https://www.google.com/search?q=the+grill+jabalpur"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary mt-6 inline-block"
            >
              See All Reviews on Google
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="section-padding">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-white p-8 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-[#F39C12] fill-current" />
                  ))}
                </div>
                <p className="text-gray-700 mb-6 italic text-lg leading-relaxed">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <div>
                    <p className="font-semibold text-[#2C3E50] text-lg">{testimonial.name}</p>
                    <p className="text-sm text-gray-500">{testimonial.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Testimonials - Full Width */}
      <section className="section-padding bg-[#2C3E50] text-white">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-8 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
              Highlights from Our Guests
            </h2>

            <div className="space-y-8">
              <div className="bg-white/10 p-6 rounded-lg">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-[#F39C12] fill-current" />
                  ))}
                </div>
                <p className="text-xl mb-4 italic">
                  "The staff is incredibly humble and helpful. I was genuinely impressed by the ambience and service. The food quality is outstanding!"
                </p>
                <p className="font-semibold">- Nisha</p>
              </div>

              <div className="bg-white/10 p-6 rounded-lg">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-[#F39C12] fill-current" />
                  ))}
                </div>
                <p className="text-xl mb-4 italic">
                  "My family members are crazy for this place. The taste is the same since so many years. It's a foodie's paradise!"
                </p>
                <p className="font-semibold">- Jasleen Hora</p>
              </div>

              <div className="bg-white/10 p-6 rounded-lg">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-[#F39C12] fill-current" />
                  ))}
                </div>
                <p className="text-xl mb-4 italic">
                  "Never disappoints! Every dish tastes fresh, perfectly balanced in spices, salt, and oil. The consistency in quality is remarkable."
                </p>
                <p className="font-semibold">- Prashant Pawar</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-[#FFF8F0]">
        <div className="container text-center">
          <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#2C3E50' }}>
            Join Our Happy Customers
          </h2>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            Experience the food and service that has earned us over {restaurantInfo.reviewCount}+ five-star reviews
          </p>
          <a href="tel:+919876543210" className="btn-primary">
            Reserve Your Table Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
